const mainDirections = [
  "Рівність",
  "Менторство",
  "Індивідуальність",
  "Адвокація",
];

const mainDirectionsImgs = [
  "../../../../assets/mainPage/first_icon.svg",
  "../../../../assets/mainPage/second_icon.svg",
  "../../../../assets/mainPage/third_icon.svg",
  "../../../../assets/mainPage/fourth_icon.svg",
];

export { mainDirections, mainDirectionsImgs };
